import { Inline } from "PFComponents/containers";
import { Icon } from "PFComponents/icon";
import { Typography } from "PFComponents/typography";

import css from "../activity_form.module.scss";

export const FormPlaceholderMessage = ({ message }: { message: string }) => (
  <Inline center className={css.formPlaceholderMessage}>
    <Icon name="missing" size="sm" color="paletteBlue2" />
    <Typography variant="labelRegular">{message}</Typography>
  </Inline>
);
